/* =====================================================================
   VOLIVY — moteur d'animations et de dates garanties (sans dépendance)
   ===================================================================== */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Dates de livraison garanties (jours ouvrés, fériés FR) ---------- */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - Math.floor(b / 4) - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return new Date(y, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  var cache = {};
  function holidays(y) {
    if (cache[y]) return cache[y];
    var e = easter(y);
    var plus = function (n) { var x = new Date(e); x.setDate(x.getDate() + n); return x; };
    var list = [new Date(y, 0, 1), plus(1), new Date(y, 4, 1), new Date(y, 4, 8), plus(39), plus(50),
      new Date(y, 6, 14), new Date(y, 7, 15), new Date(y, 10, 1), new Date(y, 10, 11), new Date(y, 11, 25)];
    var set = {};
    list.forEach(function (x) { set[x.toDateString()] = 1; });
    return (cache[y] = set);
  }
  function working(x) { var w = x.getDay(); return w !== 0 && w !== 6 && !holidays(x.getFullYear())[x.toDateString()]; }
  function addWorking(from, n) {
    var x = new Date(from); x.setHours(12, 0, 0, 0);
    var c = 0;
    while (c < n) { x.setDate(x.getDate() + 1); if (working(x)) c++; }
    return x;
  }
  function fr(x, o) { try { return x.toLocaleDateString('fr-FR', o); } catch (e) { return x.toDateString(); } }
  window.vxDeliveryDate = function (n) { return addWorking(new Date(), n || 15); };
  function fillDates(scope) {
    scope.querySelectorAll('[data-vx-date]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-vx-date') || '15', 10);
      var x = addWorking(new Date(), n);
      var style = el.getAttribute('data-vx-date-style') || 'long';
      var opts = style === 'short' ? { day: 'numeric', month: 'short' }
        : style === 'day' ? { weekday: 'long', day: 'numeric', month: 'long' }
        : { weekday: 'long', day: 'numeric', month: 'long' };
      var txt = fr(x, opts);
      if (el.textContent !== txt) el.textContent = txt;
      if (el.tagName === 'TIME') el.setAttribute('datetime', x.getFullYear() + '-' + String(x.getMonth() + 1).padStart(2, '0') + '-' + String(x.getDate()).padStart(2, '0'));
    });
    scope.querySelectorAll('[data-vx-today]').forEach(function (el) {
      var t = fr(new Date(), { weekday: 'long', day: 'numeric', month: 'long' });
      if (el.textContent !== t) el.textContent = t;
    });
  }

  /* ---------- Découpe des titres mot par mot ---------- */
  function split(el) {
    if (el.__vxSplit) return;
    el.__vxSplit = true;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var parts = ch.textContent.split(/(\s+)/), frag = d.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
            var w = d.createElement('span'), s = d.createElement('span');
            w.className = 'vx-w'; s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          ch.parentNode.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && ch.tagName !== 'BR' && ch.tagName !== 'SVG') walk(ch);
      });
    })(el);
    el.classList.add('vx-split');
  }

  /* ---------- Apparition au défilement ---------- */
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-vx-count')), t0 = 0, dur = 1500;
    if (reduce || isNaN(to)) { el.textContent = el.getAttribute('data-vx-count'); return; }
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur), v = Math.round(to * (1 - Math.pow(1 - p, 4)));
      el.textContent = v;
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
    setTimeout(function () { el.textContent = String(to); }, dur + 400);
  }
  var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.hasAttribute('data-vx-count')) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }) : null;
  function watch(el) {
    if (el.__vxWatched) return;
    el.__vxWatched = true;
    if (!io) { el.classList.add('is-in'); if (el.hasAttribute('data-vx-count')) el.textContent = el.getAttribute('data-vx-count'); return; }
    io.observe(el);
  }

  /* Habillage automatique des blocs du thème (cartes, titres de sections) */
  function autoReveal(scope) {
    scope.querySelectorAll('main product-card').forEach(function (card) {
      var li = card.closest('li') || card;
      if (li.closest('.vx, [data-vx-skip]') || li.classList.contains('vx-r')) return;
      var idx = li.parentElement ? Array.prototype.indexOf.call(li.parentElement.children, li) : 0;
      li.classList.add('vx-r');
      li.style.setProperty('--i', idx % 4);
    });
    scope.querySelectorAll('main .shopify-section .text-block h2, main .shopify-section .vq-h2, main .product-details h1').forEach(function (h) {
      if (h.closest('.vx')) return;
      split(h);
      watch(h);
    });
  }

  /* ---------- Parallaxe, progression et en-tête ---------- */
  var px = [], prog = [], ticking = false;
  /* Sur ordinateur, Horizon fait défiler .page-wrapper et non la fenêtre */
  function scrollTop() {
    var pw = d.querySelector('.page-wrapper');
    return window.scrollY || (pw ? pw.scrollTop : 0) || 0;
  }
  function measure() {
    var vh = window.innerHeight;
    for (var i = 0; i < px.length; i++) {
      var el = px[i], box = (el.parentElement || el).getBoundingClientRect();
      if (box.bottom < -100 || box.top > vh + 100) continue;
      var speed = parseFloat(el.getAttribute('data-vx-parallax')) || 0.15;
      var center = (box.top + box.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (center * speed * -100).toFixed(2) + 'px,0) scale(' + (el.getAttribute('data-vx-scale') || 1.12) + ')';
    }
    for (var j = 0; j < prog.length; j++) {
      var p = prog[j], r = p.getBoundingClientRect();
      var start = vh * (parseFloat(p.getAttribute('data-vx-progress')) || 0.8);
      var v = Math.min(1, Math.max(0, (start - r.top) / (r.height)));
      p.style.setProperty('--p', v.toFixed(4));
    }
    root.classList.toggle('vx-scrolled', scrollTop() > 12);
    ticking = false;
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }

  /* ---------- Boutons magnétiques (souris uniquement) ---------- */
  function magnet(el) {
    if (!finePointer || reduce || el.__vxMag) return;
    el.__vxMag = true;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.28;
      el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }

  /* ---------- Onglets (sélections produits) ---------- */
  function tabs(box) {
    if (box.__vxTabs) return;
    box.__vxTabs = true;
    var btns = box.querySelectorAll('[data-vx-tab]'), panels = box.querySelectorAll('[data-vx-panel]');
    var ink = box.querySelector('[data-vx-tab-ink]');
    function place(btn) {
      if (!ink || !btn) return;
      ink.style.width = btn.offsetWidth + 'px';
      ink.style.transform = 'translate3d(' + btn.offsetLeft + 'px,0,0)';
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-vx-tab');
        btns.forEach(function (x) { var on = x === b; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-vx-panel') === id;
          p.hidden = !on;
          if (on) {
            p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in');
            var sc = p.querySelector('[data-vx-scroller]'); if (sc) sc.scrollLeft = 0;
          }
        });
        place(b);
      });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var arr = Array.prototype.slice.call(btns), k = arr.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1);
        var nb = arr[(k + arr.length) % arr.length]; nb.focus(); nb.click();
      });
    });
    var cur = box.querySelector('[data-vx-tab][aria-selected="true"]') || btns[0];
    var again = function () { place(box.querySelector('[data-vx-tab][aria-selected="true"]') || cur); };
    again(); setTimeout(again, 250); setTimeout(again, 1200);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(again);
    window.addEventListener('resize', function () { place(box.querySelector('[data-vx-tab][aria-selected="true"]')); });
  }

  /* ---------- Défilement horizontal (flèches) ---------- */
  function scroller(box) {
    if (box.__vxSc) return;
    box.__vxSc = true;
    var sc = box.querySelector('[data-vx-scroller]'); if (!sc) return;
    box.querySelectorAll('[data-vx-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.getAttribute('data-vx-scroll') === 'next' ? 1 : -1;
        sc.scrollBy({ left: dir * sc.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function init(scope) {
    scope = scope || d;
    fillDates(scope);
    autoReveal(scope);
    scope.querySelectorAll('[data-vx-split]').forEach(function (el) { split(el); watch(el); });
    scope.querySelectorAll('.vx-r, [data-vx-count], [data-vx-in]').forEach(watch);
    scope.querySelectorAll('[data-vx-parallax]').forEach(function (el) { if (!reduce && px.indexOf(el) < 0) px.push(el); });
    scope.querySelectorAll('[data-vx-progress]').forEach(function (el) { if (prog.indexOf(el) < 0) prog.push(el); });
    scope.querySelectorAll('[data-vx-magnet]').forEach(magnet);
    scope.querySelectorAll('[data-vx-tabs]').forEach(tabs);
    scope.querySelectorAll('[data-vx-scroll-box]').forEach(scroller);
    measure();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  d.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); });
  else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* contenus ajoutés plus tard (panier, filtres, recommandations) */
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; autoReveal(d); d.querySelectorAll('.vx-r').forEach(watch); fillDates(d); }, 120);
    }).observe(d.querySelector('main') || d.body, { childList: true, subtree: true });
  }
  window.VX = { init: init, addWorking: addWorking };
})();
